import {
  SIGN_IN,
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_FAILURE,
  TERMS_AND_CONDITIONS_SUCCESS,
} from '../Actiontype';

export const HandleSignIn = (SignInData, rem) => ({
  payload: SignInData,
  rememberMe: rem,
  type: SIGN_IN,
});
export const SignInSuccess = response => ({
  payload: response.data,
  type: SIGN_IN_SUCCESS,
});
export const SignInFailure = response => ({
  payload: response,
  type: SIGN_IN_FAILURE,
});

export const getTermsAndConditions = () => ({
  type: TERMS_AND_CONDITIONS,
});

export const termsAndConditionsSuccess = response => ({
  payload: response.data,
  type: TERMS_AND_CONDITIONS_SUCCESS,
});

export const termsAndConditionsFailure = response => ({
  payload: response,
  type: TERMS_AND_CONDITIONS_FAILURE,
});
